import { Fragment, useContext, useState, memo, useCallback } from "react";
import CalendarLayout from "./CalenderLayout";
import Modal from "../../../../components/controls/modal/Modal";
import ResourceDetailView from "./ResourceDetailView";
import { ResourcePlannerContext } from "../ResourcePlannerContext";

const MonthView = memo(({ formBody, dashboard }) => {
  const {
    useDetails,
    calendarHeader,
    calendarData,
    detail,
    setSelectedDays,
    setStartDate,
    setEndDate,
    setSelectedValue,
    setAddShiftView,
  } = useContext(ResourcePlannerContext);
  
  const [showDetailModal, setShowDetailModal] = useState(false);

  const handleCancel = useCallback(() => {
    setAddShiftView(false);
    setShowDetailModal(false);
    setSelectedDays([]);
    setStartDate(null);
    setEndDate(null);
    setSelectedValue(null);
  }, [setAddShiftView, setSelectedDays, setStartDate, setEndDate, setSelectedValue]);

  const handleClick = useCallback((value) => {
    setShowDetailModal(value);
  }, []);

  return (
    <Fragment>
      {showDetailModal && (
        <Modal
          title="Resource Details"
          handleCancel={handleCancel}
          handleSave={handleCancel}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          isLoading={false}
          size="large"
          calendarModalWrap={true}
          body={
            <ResourceDetailView
              formBody={formBody}
              title={"Month"}
              label={calendarHeader[detail.ind].name}
              userDetails={useDetails[detail?.userIndex]}
              shift={{ ...detail.shift }}
            />
          }
        />
      )}
      <CalendarLayout
        dashboard={dashboard}
        userData={useDetails}
        calendarData={calendarData}
        headerDate={calendarHeader}
        handleClick={handleClick}
      />
    </Fragment>
  );
});

MonthView.displayName = 'MonthView';

export default MonthView;
